import React from "react";
import DietPlan from "./DietPlan";
import { Typography } from "antd";

const DietAdvised = ({ form }) => {
  return (
    <>
      <Typography>
        <DietPlan form={form} />
        <Typography.Text>
          Liquid Diet Plan : RT feeds @ 200 ml / second Hourly
        </Typography.Text>
      </Typography>
    </>
  );
};

export default DietAdvised;
